import styled from 'styled-components';

import { neutral } from 'theme/colors';

export const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10;
  background-color: ${neutral.neu09 + '66'};
  display: flex;
  align-items: center;
  justify-content: center;

  * {
    max-width: 180px;
  }

  ${(props) =>
    props.absolute &&
    `position:absolute; 
    background-color: transparent; 
    width: 100%;
    height: 100%;
`}
  ${(props) =>
    props.relative &&
    `position:relative; 
    background-color: transparent; 
    width: auto;
    height: auto;`}
      ${(props) =>
    !props.relative &&
    `    background: rgba(249, 250, 251, 0.5);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(8.9px);
    -webkit-backdrop-filter: blur(8.9px);`}
`;
